
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import NytTagPage from './pages/NytTagPage';
import OmOs from './pages/OmOs';
import Kontakt from './pages/Kontakt';
import Projekter from './pages/Projekter';
import ServicePage from './pages/ServicePage';

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
      <Route path="/projekter" element={<Projekter />} />
      <Route path="/om-os" element={<OmOs />} />
      <Route path="/kontakt" element={<Kontakt />} />
      <Route path="/service/nyt-tag" element={<NytTagPage />} />
      <Route path="/service/:slug" element={<ServicePage />} />
    </Routes>
    </>
  );
}

export default App;
